import { useMutation } from "@tanstack/react-query";
import { saveTripadvisorLocationMappings } from "../../api/bReviewsApi";

export const useSaveTripadvisorLocationMappings = () => {
  return useMutation({
    mutationKey: ["save-tripadvisor-location-mappings"],
    mutationFn: (data) => saveTripadvisorLocationMappings(data),
    onError: (error) => {
      console.error("TripAdvisor location mapping save error:", error.response || error);
    },
  });
};
